import { createSlice } from "@reduxjs/toolkit";
import {
  getAllHomepageImages,
  getAllHomepageImagesWithoutPagination,
  getHomepageImageById,
  createHomepageImage,
  updateHomepageImage,
  deleteHomepageImage,
  reorderHomepageImages,
} from "actions/homepageImages";

const initialState = {
  homepageImages: [],
  currentHomepageImage: null,
  loading: false,
  error: null,
  createLoading: false,
  updateLoading: false,
  reorderLoading: false,
};

const homepageImagesSlice = createSlice({
  name: "homepageImages",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentHomepageImage: (state) => {
      state.currentHomepageImage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllHomepageImages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllHomepageImages.fulfilled, (state, action) => {
        state.loading = false;
        state.homepageImages = action.payload.data || action.payload;
      })
      .addCase(getAllHomepageImages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(getAllHomepageImagesWithoutPagination.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getAllHomepageImagesWithoutPagination.fulfilled,
        (state, action) => {
          state.loading = false;
          state.homepageImages = action.payload;
        }
      )
      .addCase(
        getAllHomepageImagesWithoutPagination.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        }
      );

    builder
      .addCase(getHomepageImageById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHomepageImageById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentHomepageImage = action.payload;
      })
      .addCase(getHomepageImageById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(createHomepageImage.pending, (state) => {
        state.createLoading = true;
        state.error = null;
      })
      .addCase(createHomepageImage.fulfilled, (state, action) => {
        state.createLoading = false;
        state.homepageImages.push(action.payload);
      })
      .addCase(createHomepageImage.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(updateHomepageImage.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
      })
      .addCase(updateHomepageImage.fulfilled, (state, action) => {
        state.updateLoading = false;
        const index = state.homepageImages.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.homepageImages[index] = action.payload;
        }
        if (state.currentHomepageImage?.id === action.payload.id) {
          state.currentHomepageImage = action.payload;
        }
      })
      .addCase(updateHomepageImage.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(deleteHomepageImage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteHomepageImage.fulfilled, (state, action) => {
        state.loading = false;
        state.homepageImages = state.homepageImages.filter(
          (item) => item.id !== action.payload
        );
        if (state.currentHomepageImage?.id === action.payload) {
          state.currentHomepageImage = null;
        }
      })
      .addCase(deleteHomepageImage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    builder
      .addCase(reorderHomepageImages.pending, (state) => {
        state.reorderLoading = true;
        state.error = null;
      })
      .addCase(reorderHomepageImages.fulfilled, (state, action) => {
        state.reorderLoading = false;
        state.homepageImages = action.payload;
      })
      .addCase(reorderHomepageImages.rejected, (state, action) => {
        state.reorderLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearError, clearCurrentHomepageImage } =
  homepageImagesSlice.actions;
export default homepageImagesSlice.reducer;
